import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

const api = axios.create({
  baseURL: import.meta.env.VUE_APP_API_URL,
  withCredentials: true,
});

let isRefreshTokenInProgress: Promise<any> | null = null;

type PendingRequest = {
  resolve: (value?: unknown) => void;
  reject: (reason?: any) => void;
  config: AxiosRequestConfig;
};
const requestQueue: PendingRequest[] = [];

async function getRefreshToken() {
  const doLogout = () => {
    localStorage.clear();
    location.reload();
  };

  try {
    const url = import.meta.env.VUE_APP_API_URL + "v1/refresh-cookie-token";
    const response = await axios.post(url, null, { withCredentials: true });
    return response;
  } catch (error: any) {
    if ([401, 412].includes(error?.response?.status)) {
      doLogout();
    }
    throw error;
  }
}

api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status !== 401) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    if (!isRefreshTokenInProgress) {
      isRefreshTokenInProgress = getRefreshToken()
        .then((res) => {
          isRefreshTokenInProgress = null;
          requestQueue.forEach(({ resolve, reject, config }) => {
            api.request(config).then(resolve).catch(reject);
          });
          requestQueue.length = 0;
          return res;
        })
        .catch((refreshError) => {
          requestQueue.forEach(({ reject }) => reject(refreshError));
          requestQueue.length = 0;
          isRefreshTokenInProgress = null;
          throw refreshError;
        });
    }
    return new Promise((resolve, reject) => {
      requestQueue.push({ resolve, reject, config: originalRequest });
    });
  }
);

export default api;
